import { GeneralStyle } from '@website-builder/model/style/general-style';

export class NewsletterStyle extends GeneralStyle {
  layout = 'uk-child-width-expand@s';
  size = '';
  style = '';
  columnGap = 'uk-grid uk-grid-medium';
  inputColor = 'uk-color-black';
  font = 'tb-font-primary';

  static normalize(styles: Partial<NewsletterStyle>): NewsletterStyle {
    const generalStyles: GeneralStyle = GeneralStyle.normalize(styles);
    const pureStyles = new NewsletterStyle();

    Object.assign(pureStyles, generalStyles);

    pureStyles.layout = styles.layout ?? pureStyles.layout;
    pureStyles.size = styles.size ?? pureStyles.size;
    pureStyles.style = styles.style ?? pureStyles.style;
    pureStyles.columnGap = styles.columnGap ?? pureStyles.columnGap;
    pureStyles.inputColor = styles.inputColor ?? pureStyles.inputColor;
    pureStyles.font = styles.font ?? pureStyles.font;

    return pureStyles;
  }
}
